import { render, staticRenderFns } from "./AddMovieDialog.vue?vue&type=template&id=7666504e"
import script from "./AddMovieDialog.vue?vue&type=script&lang=ts"
export * from "./AddMovieDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports